var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#00B0A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.95801C10.5166 8.95801 8.95831 10.5163 8.95831 12.4997C8.95831 14.483 10.5166 16.0413 12.5 16.0413C14.4833 16.0413 16.0416 14.483 16.0416 12.4997C16.0416 10.5163 14.4833 8.95801 12.5 8.95801ZM12.5 14.6247C11.2958 14.6247 10.375 13.7038 10.375 12.4997C10.375 11.2955 11.2958 10.3747 12.5 10.3747C13.7041 10.3747 14.625 11.2955 14.625 12.4997C14.625 13.7038 13.7041 14.6247 12.5 14.6247Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1667 6.83366H15.9L14.625 5.41699H10.375L9.10002 6.83366H6.83335C6.05419 6.83366 5.41669 7.47116 5.41669 8.25033V16.7503C5.41669 17.5295 6.05419 18.167 6.83335 18.167H18.1667C18.9459 18.167 19.5834 17.5295 19.5834 16.7503V8.25033C19.5834 7.47116 18.9459 6.83366 18.1667 6.83366ZM18.1667 16.7503H6.83335V8.25033H9.66669L10.9417 6.83366H13.9167L15.3334 8.25033H18.1667V16.7503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.959e006fa2a8558103addf97332f20a9.svg";
export { ForwardRef as ReactComponent };